import { render, staticRenderFns } from "./EasyDataForm.vue?vue&type=template&id=17876544"
import script from "./EasyDataForm.vue?vue&type=script&lang=js"
export * from "./EasyDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports